import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
import SimpleLoading from '@/materials/atoms/SimpleLoading.vue';
import SoundLoading from '@/materials/atoms/SoundLoading.vue';
export default /*#__PURE__*/ _defineComponent({
    props: {
        mode: { default: 'sound' }
    },
    setup(__props) {
        const props = __props;
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                (props.mode === 'simple')
                    ? (_openBlock(), _createBlock(SimpleLoading, {
                        key: 0,
                        class: "simple"
                    }))
                    : _createCommentVNode("", true),
                (props.mode === 'sound')
                    ? (_openBlock(), _createBlock(SoundLoading, {
                        key: 1,
                        class: "sound"
                    }))
                    : _createCommentVNode("", true)
            ], 64));
        };
    }
});
